import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate, state } from '@angular/animations';

@Component({
  selector: 'app-video',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './video.component.html',
  styleUrl: './video.component.scss',
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ]),
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('500ms ease-out', style({ transform: 'translateX(0)' }))
      ])
    ]),
    trigger('videoState', [
      state('playing', style({
        transform: 'scale(1)',
        opacity: 1
      })),
      state('changing', style({
        transform: 'scale(0.98)',
        opacity: 0.5
      })),
      transition('playing <=> changing', animate('300ms ease-in-out'))
    ])
  ]
})
export class VideoComponent implements OnInit {
  videosArr = [
    {
      videoUrl: 'assets/images/gallery/meena_story.mp4',
      thumbnailUrl: 'assets/images/gallery/meena_story.webp',
      title: 'No More Acidity & Constipation – Meena’s Tummy Detox Story!',
      description: `🌿✨ A Happy Gut, A Happy Life! ✨🌿 Meet Meena Agarvat, who struggled with acidity & constipation until she tried Tummy Detox! 🌱💚 After a month, she feels lighter, healthier, and free from discomfort. 😊🎉 Join Meena and thousands improving their digestion with Herbs LYF’s Tummy Detox! 🌿💚 Order now on Amazon, Flipkart, or 🌐 www.herbslyf.com.`
    },
    {
      videoUrl: 'assets/images/gallery/healthy_gut.mp4',
      thumbnailUrl: 'assets/images/gallery/healthy_gut.png',
      title: 'Feeling heavy and bloated? It’s time for a gentle reset! 🌿',
      description: `Herbs.lyf’s Tummy Detox is your natural solution to relieve constipation, improve digestion, and bring your gut back to balance. 💚 Safe, effective, and powered by nature! 🍃✨`
    },
    {
      videoUrl: 'assets/images/gallery/transform_gut.mp4',
      thumbnailUrl: 'assets/images/gallery/transform_gut.png',
      title: 'Transform your #gut #health, the natural way! |Tummy Detox',
      description: `Trust Herbs.lyf's Tummy Detox to gently relieve constipation 🌿and restore digestive balance. With the power of nature,💚 we bring you a reliable, safe, and effective solution.✨💪`
    },
    {
      videoUrl: 'assets/images/gallery/boost_digestive.mp4',
      thumbnailUrl: 'assets/images/gallery/boost_digestive.png',
      title: `Boost Your #Digestive #Health Naturally with Herbs.Lyf's Detox Blend |`,
      description: `It’s amazing how a healthy gut can change everything. 🌿 With a gentle blend of Ajowain, Saunf, Senna, Rose, Yashtimadhu, and Haritaki, you can start feeling more balanced and comfortable in no time. 💪 It’s like giving your body a little extra love. 🌸 If you want to feel lighter and more at ease, this natural remedy might be just what you need!✨💚`
    },
    {
      videoUrl: 'assets/images/gallery/better_digestion.mp4',
      thumbnailUrl: 'assets/images/gallery/better_digestion.png',
      title: 'Natural Tummy Detox for Better Digestion and Energy|',
      description: `Revitalize your digestive 💚 health with our all-natural tummy detox formula. Crafted with a blend of potent 🌿 ingredients of Meshasringi, Methi, Tejpatta, Jamun, Bilva, and Kadi Patta, 😊 it's designed to cleanse and rejuvenate your system.💪🍃`
    },
    {
      videoUrl: 'assets/images/gallery/magic_tummy.mp4',
      thumbnailUrl: 'assets/images/gallery/magic_tummy.png',
      title: 'Exploring the Magic of Tummy Detox |',
      description: `Digestive wellness with Tummy Detox by Herbs LYF! Natural solution to bloating, gas, and digestive discomfort. Discover the powerful ingredients Yashtimadhu, Saunf, Haritaki, Ajwain, Senna, and Rose their harmonious benefits as we delve into how Tummy Detox can transform your digestive health.`
    },

    ///Fix Title
    {
      videoUrl: 'assets/images/gallery/manage_diabetes.mp4',
      thumbnailUrl: 'assets/images/gallery/manage_diabetes.png',
      title: '',
      description: ''
    },
    {
      videoUrl: 'assets/images/gallery/manage_sugar_label.mp4',
      thumbnailUrl: 'assets/images/gallery/manage_sugar_label.png',
      title: '',
      description: ''
    },
    {
      videoUrl: 'assets/images/gallery/Introducing_tummy.mp4',
      thumbnailUrl: 'assets/images/gallery/Introducing_tummy.png',
      title: '',
      description: ''
    },
    {
      videoUrl: 'assets/images/gallery/Introducing_gluco.mp4',
      thumbnailUrl: 'assets/images/gallery/Introducing_gluco.png',
      title: '',
      description: ''
    },
    {
      videoUrl: 'assets/images/gallery/HerbsLYF_republic.mp4',
      thumbnailUrl: 'assets/images/gallery/HerbsLYF_republic.png',
      title: '',
      description: ''
    },
    {
      videoUrl: 'assets/images/gallery/relief_constipation.mp4',
      thumbnailUrl: 'assets/images/gallery/relief_constipation.png',
      title: '',
      description: ''
    },
    {
      videoUrl: 'assets/images/gallery/Glluco_review.mp4',
      thumbnailUrl: 'assets/images/gallery/Glluco_review.png',
      title: '',
      description: ''
    },
    {
      videoUrl: 'assets/images/gallery/gluco_reel_3.mp4',
      thumbnailUrl: 'assets/images/gallery/gluco_reel_3.png',
      title: '',
      description: ''
    },
    {
      videoUrl: 'assets/images/gallery/gluco_reel_2.mp4',
      thumbnailUrl: 'assets/images/gallery/gluco_reel_2.png',
      title: '',
      description: ''
    },
    {
      videoUrl: 'assets/images/gallery/gluco_reel_1.mp4',
      thumbnailUrl: 'assets/images/gallery/gluco_reel_1.png',
      title: '',
      description: ''
    },
  ];

  selectedVideo = this.videosArr[0];
  videoState = 'playing';
  activeIndex = 0;

  ngOnInit() {
    // Add any initialization logic here
  }

  playVideo(video: any, index: number): void {
    if (this.selectedVideo.videoUrl !== video.videoUrl) {
      this.videoState = 'changing';
      this.activeIndex = index;
      setTimeout(() => {
        this.selectedVideo = video;
        this.videoState = 'playing';
      }, 300);
    }
  }

  isVideoActive(index: number): boolean {
    return this.activeIndex === index;
  }
}
